var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"width":"95%","margin-left":"2.5%","margin-right":"2.5%"}},[_c('i-app-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }